import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "week",
  measure: "Starting Weeks of Supply", // Default measure - will be updated dynamically
  segments: ["sku", "location"],
  minDate: dayjs.utc().startOf("year").toDate(),
  maxDate: dayjs.utc().add(1, "year").startOf("year").toDate(),
  filters: [],
  postFilters: [],
};
